import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    formataMesAnoTextoComBarra,
} from '../../../business-components/Date/Date'

import {
    formataValor,
    formataPerc,
} from '../../../business-components/Formata/Formata'

import {
    round
} from '../../../business-components/round/round'

import {
    pesquisaList,
    pesquisaDescricaoList,
} from '../../../business-rules/List/ListService'

import titularList from '../../../business-rules/List/titularList'

import familiaList from '../../../business-rules/List/familiaList'

import familiaresList from '../../../business-rules/List/familiaresList'

import tipoPatrimonioImobilizadoList from '../../../business-rules/List/tipoPatrimonioImobilizadoList'

import tipoReceitaMensalList from '../../../business-rules/List/tipoReceitaMensalList'

import tipoRecursoFinanceiroList from '../../../business-rules/List/tipoRecursoFinanceiroList'

import tipoDiaDiaList from '../../../business-rules/List/tipoDiaDiaList'

import tipoEducacaoList from '../../../business-rules/List/tipoEducacaoList'

import tipoFinanciamentoList from '../../../business-rules/List/tipoFinanciamentoList'

import tipoProjetoVidaSonhoList from '../../../business-rules/List/tipoProjetoVidaSonhoList'

import seguradoraList from '../../../business-rules/List/SeguroVida/seguradoraList'

import {
    dadosCompletosLinhaPatrimonioImobilizado,
} from '../garantias-form/GarantiasServicePatrimonioImobilizado'

import {
    dadosCompletosLinhaReceitaMensal,
} from '../garantias-form/GarantiasServiceReceitaMensal'

import {
    dadosCompletosLinhaRecursosFinanceiros,
} from '../garantias-form/GarantiasServiceRecursosFinanceiros'

import {
    dadosCompletosLinhaSeguroVidaApolice,
    seguroVidaApoliceAtiva,
} from '../seguroVida-form/SeguroVidaServiceSeguroVidaApolice'

import {
    dadosCompletosLinhaDiaDia,
} from '../despesas-form/DespesasServiceDiaDia'

import {
    dadosCompletosLinhaEducacao,
} from '../despesas-form/DespesasServiceEducacao'

import {
    dadosCompletosLinhaFinanciamento,
} from '../despesas-form/DespesasServiceFinanciamento'

import {
    dadosCompletosLinhaProjetoVidaSonho,
} from '../projetoVidaSonho-form/ProjetoVidaSonhoServiceProjetoVidaSonho'

import {
    calculaDescricaoGrupoDespesa
} from '../estudo-form/EstudoService'



export const processaRegistrosDefaultIniciaisExclusaoDespesasGarantias = ( values ) => {

    if (!values.exclusaoDespesasGarantias) {

        values.exclusaoDespesasGarantias = JSON.parse(JSON.stringify(HARDCODE.exclusaoDespesasGarantiasInit))
    }
}



export const incluiLinhaExclusaoDespesasGarantiasList = ( array, grupo, exclusaoDespesasGarantiasList, linha, familiarList,
    familiar, receitaDespesaList, tipo, valor, valor2, ordem, descricaoEspecifica, descricaoComplemento ) => {

    const descricao = array + (grupo ? LABEL.traco + grupo : '') + LABEL.traco + pesquisaList(familiarList, familiar).descricao + LABEL.traco +
        (descricaoEspecifica
            ?
                descricaoEspecifica
            :
                pesquisaList(receitaDespesaList, tipo).descricao + LABEL.traco + formataValor(round(valor, 2), 2) +
                    (valor2 ? ' / ' + formataValor(round(valor2, 2), 2) : '')
        ) +
            (descricaoComplemento ? descricaoComplemento : '')
            
    exclusaoDespesasGarantiasList.push(
        {
            id: array + '/' + linha.id,
            descricao: descricao,
            ordem: ordem + descricao,
        }
    )
}

export const obtemExclusaoDespesasGarantiasList = ( values, id ) => {

    let exclusaoDespesasGarantiasList = []



    values.receitaMensal?.forEach( ( linhaReceitaMensal, index ) => {

        if (
                dadosCompletosLinhaReceitaMensal(linhaReceitaMensal) &&
                (
                    linhaReceitaMensal.familiar === HARDCODE.idFamiliarCliente ||
                    linhaReceitaMensal.familiar === HARDCODE.idFamiliarConjuge
                )
        ) {

            incluiLinhaExclusaoDespesasGarantiasList(LABEL.receitaMensal, null, exclusaoDespesasGarantiasList, linhaReceitaMensal,
                familiaresList(values), linhaReceitaMensal.familiar, tipoReceitaMensalList,
                    linhaReceitaMensal.tipoReceitaMensal, linhaReceitaMensal.valor, null, '01', null,
                        (linhaReceitaMensal.descricaoOutras
                            ?
                                LABEL.traco + linhaReceitaMensal.descricaoOutras
                            :
                                ''
                        ) +
                            (linhaReceitaMensal.mesAnoInicial
                                ?
                                    LABEL.traco + formataMesAnoTextoComBarra(linhaReceitaMensal.mesAnoInicial) +
                                        (linhaReceitaMensal.mesAnoFinal
                                            ? 
                                                LABEL.traco + formataMesAnoTextoComBarra(linhaReceitaMensal.mesAnoFinal)
                                            :
                                                ''
                                        )
                                :
                                    ''
                            )
            )
        }
    })



    values.diaDia?.forEach( ( linhaDiaDia, index ) => {

        if (
                dadosCompletosLinhaDiaDia(linhaDiaDia) &&
                (
                    linhaDiaDia.familiar === HARDCODE.idFamiliarCliente ||
                    linhaDiaDia.familiar === HARDCODE.idFamiliarConjuge
                )
        ) {

            incluiLinhaExclusaoDespesasGarantiasList(LABEL.diaDia,
                calculaDescricaoGrupoDespesa(linhaDiaDia.grupoDespesa, linhaDiaDia.descricaoGrupoDespesaOutras),
                    exclusaoDespesasGarantiasList, linhaDiaDia, familiaresList(values), linhaDiaDia.familiar,
                        tipoDiaDiaList, linhaDiaDia.tipoDiaDia, linhaDiaDia.valor, linhaDiaDia.valorNaAposentadoria, '02', null,
                        (linhaDiaDia.descricaoDiversasOutros ? LABEL.traco + linhaDiaDia.descricaoDiversasOutros : '') +
                            (linhaDiaDia.mesAnoInicial
                                ?
                                    LABEL.traco + formataMesAnoTextoComBarra(linhaDiaDia.mesAnoInicial) +
                                        (linhaDiaDia.mesAnoFinal
                                            ? 
                                                LABEL.traco + formataMesAnoTextoComBarra(linhaDiaDia.mesAnoFinal)
                                            :
                                                ''
                                        )
                                :
                                    ''
                            )
            )
        }
    })



    values.educacao?.forEach( ( linhaEducacao, index ) => {

        if (
                dadosCompletosLinhaEducacao(linhaEducacao)
        ) {

            incluiLinhaExclusaoDespesasGarantiasList(LABEL.educacao, null, exclusaoDespesasGarantiasList,
                linhaEducacao, familiaresList(values), linhaEducacao.familiar,
                    tipoEducacaoList, linhaEducacao.tipoEducacao, linhaEducacao.valor, null, '03', null, null)
        }
    })



    values.financiamento?.forEach( ( linhaFinanciamento, index ) => {

        if (
                dadosCompletosLinhaFinanciamento(linhaFinanciamento) &&
                (
                    linhaFinanciamento.familiar === HARDCODE.idFamiliarCliente ||
                    linhaFinanciamento.familiar === HARDCODE.idFamiliarConjuge
                )
        ) {

            incluiLinhaExclusaoDespesasGarantiasList(LABEL.financiamento, null, exclusaoDespesasGarantiasList,
                linhaFinanciamento, familiaresList(values), linhaFinanciamento.familiar,
                    tipoFinanciamentoList, linhaFinanciamento.tipoFinanciamento, linhaFinanciamento.valorParcela, null,
                        '04', null, linhaFinanciamento.descricaoOutros ? LABEL.traco + linhaFinanciamento.descricaoOutros : '')
        }
    })



    values.projetoVidaSonho?.forEach( ( linhaProjetoVidaSonho, index ) => {

        if (
                dadosCompletosLinhaProjetoVidaSonho(values, linhaProjetoVidaSonho)
        ) {

            incluiLinhaExclusaoDespesasGarantiasList(LABEL.projetoVidaSonho, null, exclusaoDespesasGarantiasList,
                linhaProjetoVidaSonho, familiaList(values), linhaProjetoVidaSonho.familiar,
                    tipoProjetoVidaSonhoList, linhaProjetoVidaSonho.tipoProjetoVidaSonho, linhaProjetoVidaSonho.valor, null,
                        '05', null, linhaProjetoVidaSonho.descricao ? LABEL.traco + linhaProjetoVidaSonho.descricao : '')
        }
    })



    values.patrimonioImobilizado?.forEach( ( linhaPatrimonioImobilizado, index ) => {

        if (
                dadosCompletosLinhaPatrimonioImobilizado(linhaPatrimonioImobilizado) &&
                (
                    linhaPatrimonioImobilizado.familiar === HARDCODE.idFamiliarCliente ||
                    linhaPatrimonioImobilizado.familiar === HARDCODE.idFamiliarConjuge ||
                    linhaPatrimonioImobilizado.familiar === HARDCODE.idFamiliarCasal
                )
        ) {

            incluiLinhaExclusaoDespesasGarantiasList(LABEL.patrimonioImobilizado, null, exclusaoDespesasGarantiasList,
                linhaPatrimonioImobilizado, titularList(values, 'completo'), linhaPatrimonioImobilizado.familiar,
                    tipoPatrimonioImobilizadoList, linhaPatrimonioImobilizado.tipoPatrimonioImobilizado,
                        linhaPatrimonioImobilizado.valor, null, '06', null,
                            linhaPatrimonioImobilizado.descricaoOutros ? LABEL.traco + linhaPatrimonioImobilizado.descricaoOutros : '')
        }
    })



    values.recursosFinanceiros?.forEach( ( linhaRecursosFinanceiros, index ) => {

        if (
                dadosCompletosLinhaRecursosFinanceiros(linhaRecursosFinanceiros) &&
                (
                    linhaRecursosFinanceiros.familiar === HARDCODE.idFamiliarCasal ||
                    linhaRecursosFinanceiros.familiar === HARDCODE.idFamiliarCliente ||
                    linhaRecursosFinanceiros.familiar === HARDCODE.idFamiliarConjuge
                )
        ) {

            incluiLinhaExclusaoDespesasGarantiasList(LABEL.recursosFinanceiros, null, exclusaoDespesasGarantiasList,
                linhaRecursosFinanceiros, titularList(values, 'completo'), linhaRecursosFinanceiros.familiar,
                    tipoRecursoFinanceiroList, linhaRecursosFinanceiros.tipoRecursoFinanceiro,
                        linhaRecursosFinanceiros.valor, linhaRecursosFinanceiros.valorAporteDividendos, '07', null,
                            (linhaRecursosFinanceiros.descricaoOutros
                                ?
                                    LABEL.traco + linhaRecursosFinanceiros.descricaoOutros
                                :
                                    ''
                            ) +
                                (linhaRecursosFinanceiros.percRentabilidadeAnualRecursoFinanceiro ||
                                    linhaRecursosFinanceiros.percRentabilidadeAnualRecursoFinanceiro === 0
                                        ?
                                            LABEL.traco + formataPerc(
                                                round(linhaRecursosFinanceiros.percRentabilidadeAnualRecursoFinanceiro, 2))
                                        : 
                                            ''
                                )
            )
        }
    })



    values.seguroVidaCotacao?.forEach( (linhaSeguroVidaCotacao, indexSeguroVidaCotacao) => {

        if (!linhaSeguroVidaCotacao.numeroCotacao) {

            values.seguroVidaCotacao[indexSeguroVidaCotacao].numeroCotacao = linhaSeguroVidaCotacao.id
        }

        if (
                dadosCompletosLinhaSeguroVidaApolice(linhaSeguroVidaCotacao)
        ) {

            incluiLinhaExclusaoDespesasGarantiasList(LABEL.cotacao + ' - ' + LABEL.seguroVida, null, exclusaoDespesasGarantiasList,
                linhaSeguroVidaCotacao, familiaresList(values), linhaSeguroVidaCotacao.familiar,
                    null, null, null, null, '08',
                        (linhaSeguroVidaCotacao.seguradora
                            ?
                                pesquisaDescricaoList(seguradoraList(), linhaSeguroVidaCotacao.seguradora) + ' '
                            :
                                ''
                        ) + linhaSeguroVidaCotacao.numeroCotacao, null)
        }
    })




    values.seguroVidaApolice?.forEach( (linhaSeguroVidaApolice, indexSeguroVidaApolice) => {

        if (!linhaSeguroVidaApolice.numeroApolice) {

            values.seguroVidaApolice[indexSeguroVidaApolice].numeroApolice = linhaSeguroVidaApolice.id
        }

        if (
                dadosCompletosLinhaSeguroVidaApolice(linhaSeguroVidaApolice) &&
                seguroVidaApoliceAtiva(linhaSeguroVidaApolice.statusApolice) &&
                (
                    linhaSeguroVidaApolice.familiar === HARDCODE.idFamiliarCliente ||
                    linhaSeguroVidaApolice.familiar === HARDCODE.idFamiliarConjuge
                )
        ) {

            incluiLinhaExclusaoDespesasGarantiasList(LABEL.seguroVida, null, exclusaoDespesasGarantiasList,
                linhaSeguroVidaApolice, familiaresList(values), linhaSeguroVidaApolice.familiar,
                    null, null, null, null, '09', LABEL.apolice + ': ' + linhaSeguroVidaApolice.numeroApolice, null)
        }
    })



    if (exclusaoDespesasGarantiasList.length === 0) {

        exclusaoDespesasGarantiasList.push(
            {
                id: '0',
                descricao: '',
                ordem: '',
            }
        )
    }



    let index = values.exclusaoDespesasGarantias.length - 1

    while (index >= 0) {

        if (
                values.exclusaoDespesasGarantias[index].id &&
                !pesquisaList(exclusaoDespesasGarantiasList, values.exclusaoDespesasGarantias[index].id).id
        ) {

            values.exclusaoDespesasGarantias.splice(index, 1)
        }

        index -= 1
    }



    index = exclusaoDespesasGarantiasList.length - 1

    while (index >= 0) {

        if (
                exclusaoDespesasGarantiasList[index].id !== id &&
                pesquisaList(values.exclusaoDespesasGarantias, exclusaoDespesasGarantiasList[index].id).id
        ) {

            exclusaoDespesasGarantiasList.splice(index, 1)
        }

        index -= 1
    }

    return exclusaoDespesasGarantiasList
}